import { frontendURL } from '../../../../helper/URLHelper';

const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/account-chat-settings'),
      component: SettingsContent,
      props: {
        headerTitle: 'Account Chat Setting',
        icon: 'content-settings',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'settings_account_chat_setting',
          roles: ['administrator'],
          component: Index,
        },
      ],
    },
  ],
};
